import React from "react";
import { BrowserRouter, Route, Switch, Redirect } from "react-router-dom";
import Topnav from "./components/common/Topnav";
import Footer from "./components/common/Footer";
import Header from "./components/common/Header";
import Landing from "./pages/index";
import Register from "./pages/register";
import Login from "./pages/login";
import Vacancies from "./pages/vacancies";
import Apply from "./pages/apply";
import TopnavAdmin from "./components/common/TopnavAdmin";
import Office from "./pages/office";
import CreateJob from "./pages/createJob";
import Applicants from "./pages/applicants";
import ApplicationGuidelnes from "./pages/applicationGudilnes";
import HowItWorks from "./pages/howItWorks";
import EditJob from "./pages/editJob";
import ApplicantView from "./pages/applicantView";
import About from "./pages/about";
import NoMatch from "./pages/noMatch";
import Report from "./pages/report";
import Faq from "./pages/faq";
import {connect} from 'react-redux'

const MainLayout = props => (
  <div>
    <Header />
    <Topnav />
    <div id="hero" />
    {props.children}
  </div>
);

const AdminLayout = props => (
  <div className="bg-near-white">
    <TopnavAdmin />
    {props.children}
  </div >
)


{
  /*<div className="bg-near-white">
    <TopnavAdmin />
    {props.children}
</div >*/
}

const AppRoute = ({ component: Component, layout: Layout, ...rest }) => (
  <Route
    {...rest}
    render={props => (
      <Layout>
        <Component {...props} />
      </Layout>
    )}
  />
);

export default () => (
  <BrowserRouter>
    <div>
      <Switch>
        <AppRoute
          exact
          path="/office"
          component={Office}
          layout={AdminLayout}
        />
        <AppRoute
          exact
          path="/office/create"
          component={CreateJob}
          layout={AdminLayout}
        />
        <AppRoute
          exact
          path="/office/edit-job/:id"
          component={EditJob}
          layout={AdminLayout}
        />
        <AppRoute
          exact
          path="/office/job/:id"
          component={Applicants}
          layout={AdminLayout}
        />
        <AppRoute
          exact
          path="/office/applicant/view/:id/:jobId"
          component={ApplicantView}
          layout={AdminLayout}
        />
        <AppRoute
          exact
          path="/report"
          component={Report}
          layout={AdminLayout}
        />
        <AppRoute path="/" exact component={Landing} layout={MainLayout} />
        <AppRoute
          path="/register"
          exact
          component={Register}
          layout={MainLayout}
        />
        <AppRoute path="/login" exact component={Login} layout={MainLayout} />
        <AppRoute
          path="/vacancies"
          exact
          component={Vacancies}
          layout={MainLayout}
        />
        <AppRoute
          path="/apply/:id"
          exact
          component={Apply}
          layout={MainLayout}
        />
        <AppRoute
          path="/application-guidelines"
          exact
          component={ApplicationGuidelnes}
          layout={MainLayout}
        />
        <AppRoute
          path="/how-it-works"
          exact
          component={HowItWorks}
          layout={MainLayout}
        />
        <AppRoute path="/about" exact component={About} layout={MainLayout} />
        <AppRoute path="/faq" exact component={Faq} layout={MainLayout} />
        <Route component={NoMatch} />
      </Switch>
      <Footer />
    </div>
  </BrowserRouter>
);



// WEBPACK FOOTER //
// ./src/App.js